module.exports = __webpack_public_path__ + "static/media/iconmonstr-favorite-2-240.fd52aef8.png";